import Dialogs = require("VSS/Controls/Dialogs");
import WorkItemTrackingResources = require("WorkItemTracking/Scripts/Resources/TFS.Resources.WorkItemTracking");
import WITOM = require("WorkItemTracking/Scripts/TFS.WorkItemTracking");
import * as React from "react";
import * as ReactDOM from "react-dom";
import { FollowType, getFollowsState } from "WorkItemTracking/Scripts/Utils/FollowsUtils";
import { CustomFollowDialogContent } from "./CustomFollowDialogContent";

export interface CustomFollowDialogResult {
    prevType: FollowType;
    selectedType: FollowType;
    selectedCheckbox: string[];
}

export interface CustomFollowDialogOptions extends Dialogs.IModalDialogOptions {
    workItem?: WITOM.WorkItem;
}

export class CustomFollowDialog extends Dialogs.ModalDialogO<CustomFollowDialogOptions> {
    private result: CustomFollowDialogResult;

    constructor(options?) {
        super({
            ...options,
            cssClass: "custom-follow-dialog",
            minHeight: 460,
            minWidth: 450
        });
    }

    public initialize() {
        super.initialize();
        this.result = {
            prevType: null,
            selectedType: null,
            selectedCheckbox: []
        };
        this.setTitle(WorkItemTrackingResources.CustomFollowDialogTitle);
        this._queryCurrSubscription();
    }

    public getDialogResult() {
        return this.result;
    }

    public onClose(e?) {
        this._options.workItem = null;
        super.onClose(e);
    }

    private _handleSelectRadio = (selectedId: FollowType): void => {
        this.result.selectedType = selectedId;
        if (selectedId != FollowType.Custom) {
            this.result.selectedCheckbox = [];
        }
        this._updateOkButtonStatus();
    };

    private _handleSelectCheckbox = (checkbox: string[]): void => {
        this.result.selectedCheckbox = checkbox;
        this._updateOkButtonStatus();
    };

    private _decorate() {
        const $element = this._element;
        const $content = $("<div/>").appendTo($element);
        ReactDOM.render(
            React.createElement(CustomFollowDialogContent, {
                currFollowType: this.result.selectedType,
                currCheckbox: this.result.selectedCheckbox,
                onSelectRadio: this._handleSelectRadio,
                onSelectCheckbox: this._handleSelectCheckbox
            }),
            $content[0]
        );
    }

    private _updateOkButtonStatus() {
        if (this.result.selectedType === FollowType.Custom && this.result.selectedCheckbox.length == 0) {
            this.updateOkButton(false);
        } else {
            this.updateOkButton(true);
        }
    }

    private _queryCurrSubscription() {
        const workItem = this._options.workItem;

        getFollowsState(workItem).then(
            (subscription) => {
                if (subscription != null) {
                    if (subscription.description.indexOf("fieldFilters") != -1) {
                        this.result.selectedType = FollowType.Custom;
                        this.result.selectedCheckbox = JSON.parse(subscription.description).fieldFilters;
                    } else {
                        this.result.selectedType = FollowType.All;
                    }
                } else {
                    this.result.selectedType = FollowType.None;
                }
                this.result.prevType = this.result.selectedType;
                this._decorate();
            },
            () => {
                this.result.selectedType = FollowType.None;
                this.result.prevType = FollowType.None;
                this._decorate();
            }
        );
    }
}
